<template>
  <section class="wrap">
    <div class="head">
      <div class="wire"></div>
      <div class="create_class">
        <img src="../../../../assets/img/back.png"
             class="create_class_img"
             @click="goBack">
        <span class="title">{{$route.query.class_name}}----考试查看</span>
      </div>
    </div>
    <div class="publisher-create-course content">
      <el-table
        :data="gettersStudentExamPaperList.list"
        border
        style="width: 100%">
        <el-table-column label="试卷名称">
          <template slot-scope="scope">
            <span>{{scope.row.paper.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="author_name" label="题目类型">
          <template slot-scope="scope">
            <span>{{scope.row.paper.paper_type}}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时长" width="150px">
          <template slot-scope="scope">
            <span>{{scope.row.paper.test_time}}</span>
          </template>
        </el-table-column>
        <el-table-column label="试卷状态" width="120px">
          <template slot-scope="scope">
            <span>{{scope.row.end_time ? '已做答' : '未做答'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="截止时间">
          <template slot-scope="scope">
            <span v-if="scope.row.paper_school">{{scope.row.paper_school.deadline | date('yyyy-MM-dd HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openExam(scope.row);" v-if="scope.row.end_time==null">作答</el-button>
            <el-button size="mini" type="text" @click="openExam(scope.row);" v-if="scope.row.end_time!=null">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block mt20">
        <el-pagination
          :page-sizes="[15, 30, 50,100]"
          :current-page="queryParams.page"
          :page-size="queryParams.size"
          background
          layout="total,sizes, prev, pager, next"
          @size-change="changeRouteQuery({
          size: arguments[0],
          page: 1
          })"
          @current-change="changeRouteQuery({
          page: arguments[0]
          })"
          :total="+gettersStudentExamPaperList.total">
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    extend,
    pickBy,
  }  from 'lodash'
  import {
    mapGetters,
    mapActions
  } from 'vuex';
  import {
    toNumber
  } from "src/common/Fn";
  export default {
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters({
        'gettersStudentExamPaperList': 'getStudentExamPaperList',//学生班级试卷列表
      }),
      queryParams() {
        let route = this.$route.query;
        return {
          page: toNumber(route.page, 1),
          size: toNumber(route.size, 15),
          school_grade_id:route.id
        }
      },
    },

    methods: {
      ...mapActions({
        'actionStudentExamPaperAnswer': 'actionStudentExamPaperAnswerModel',//学生点击答卷
        'actionStudentGradeExamPaperList': 'actionStudentGradeExamPaperListModel',//学生班级试卷列表
      }),
      getDataList(){
        let query = this.queryParams;
        this.actionStudentGradeExamPaperList(pickBy(query));
      },
      openExam(_data){
        if(_data.end_time!=null){
          this.$router.push({
            name : 'examination_paper_preview_answer',
            query: {student_paper_id: _data.id}
          });
        }else {
          this.actionStudentExamPaperAnswer({
            student_paper_id: _data.id
          }).then(() => {
            this.$router.push({
              name : 'examination_paper_preview_answer',
              query: {student_paper_id: _data.id,cls:this.$route.query.id}
            });
          });
        }
      },
      changeRouteQuery(args) {
        let route = this.$route;
        this.$router.replace({
          name: route.name,
          params: route.params,
          query: extend({}, route.query, args)
        });
        this.$nextTick(() => {
          this.getDataList();
        });
      },

      goBack() {
        this.$router.back();
      },
    },
    created() {
      this.getDataList();
    }
  }
</script>

<style lang="scss" scoped>
  .create_class_img{
    display: inline-block;
    margin-top: 10px;
    transform: translateY(7px);
  }
  .head{
    height: 116px;
    background-color: #f5f8fa;
    padding-left: 45px;
    padding-right: 45px;
  }
  .head .wire{
    width: 100%;
    height: 1px;
  }
  .title{
    margin-top: 32px;
    display: inline-block;
    font-size: 24px;
    color: #333333;
    margin-left: 20px;
  }
  > > > .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: $--system-color-primary;
  }
  .content{
    position: relative;
    padding-left: 45px;
    padding-right: 45px;
  }
</style>
